// extracted by mini-css-extract-plugin
export var Slider = "style-module--Slider--83898";
export var SocialProfile = "style-module--SocialProfile--9856e";